import React from 'react'

const ErrorPopup = (props) => {
    const { onClose, message } = props
    return (

        <div className="error_poupcontent">

            <p>
                {message}

            </p>
            <div className="error_poupcontent_btns">

                <button className="btn" onClick={onClose}>
                    OK
                </button>
            </div>
        </div>
    )
}

export default ErrorPopup